
const grassH = 85
const grassS = 28
const grassL = 1.1


const url = import.meta.env.VITE_RESOURCE_URL
const defaultProperties = {
	grassH: grassH,
	grassS: grassS,
	grassL: grassL,
	greenLightness: 56 * grassL,
	semiGreenLightness: 50 * grassL,
	teeLightness: 45 * grassL,
	fairwayLightness: 43 * grassL,
	backgroundLightness: 37 * grassL,
	roughLightness: 33 * grassL,
	roughHue: null,
	grassBunkerLightness: 31 * grassL,
	contrastRoughness: 0.9,
	grassSizeScale: 0.8,
	foliageLightness: 1.1,
	foliageHue: 0.95,
	forestHue: 68,
	images: ['diffuse']
}
function getProperties(properties) {
	for (let key in defaultProperties) {
		if (properties[key] === undefined) {
			properties[key] = defaultProperties[key]
		}
	}
	return properties
}
export function getObjects(properties) {
	const {
		foliageHue,
		foliageLightness
	} = getProperties(properties)
	return {
		tree1: {
			foliageColor: `hsl(${Math.round(80 * foliageHue)}, 35%, ${Math.round(27 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			largeUrl: url + "mesh/MapleLarge.glb",
			scaleFactor: 0.15 * 2,
			scaleFactorLarge: 0.10,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			heigthScaleFactor: 1,
			simpleUrl: url + "mesh/SimpleTree2.glb",
			smallUrl: url + "mesh/MapleSmall.glb",
			treeType: "leaf",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		tree2: {
			foliageColor: `hsl(${Math.round(95 * foliageHue)}, 42%, ${Math.round(25 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 0.8,
			largeUrl: url + "mesh/BirchLarge.glb",
			scaleFactor: 0.113 * 2,
			scaleFactorLarge: 0.115,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			heigthScaleFactor: 1,
			simpleUrl: url + "mesh/SimpleTree2.glb",
			smallUrl: url + "mesh/BirchSmall.glb",
			treeType: "leaf",
			trunkColor: "hsl(0, 0%, 70%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		tree3: {
			foliageColor: `hsl(${Math.round(65 * foliageHue)}, 42%, ${Math.round(25 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 0.8,
			heigthScaleFactor: 1,
			largeUrl: url + "mesh/AspenLarge.glb",
			scaleFactor: 0.10 * 2,
			scaleFactorLarge: 0.11,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			simpleUrl: url + "mesh/SimpleTree2.glb",
			smallUrl: url + "mesh/AspenSmall.glb",
			treeType: "leaf",
			trunkColor: "#756F5C",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		tree4: {
			foliageColor: `hsl(${Math.round(100 * foliageHue)}, 30%, ${Math.round(20 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 0.8,
			heigthScaleFactor: 0.7,
			largeUrl: url + "mesh/TallLarge2.glb",
			scaleFactor: 0.16 * 2,
			scaleFactorLarge: 0.16,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			simpleUrl: url + "mesh/SimpleConifer2.glb",
			smallUrl: url + "mesh/TallSmall2.glb",
			treeType: "conifer",
			trunkColor: "#3A2A16",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		tree5: {
			foliageColor: `hsl(${Math.round(80 * foliageHue)}, 30%, ${Math.round(20 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 0.8,
			heigthScaleFactor: 1,
			largeUrl: url + "mesh/SpruceLarge2.glb",
			scaleFactor: 0.14 * 2,
			scaleFactorLarge: 0.15,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			simpleUrl: url + "mesh/SimpleConifer2.glb",
			smallUrl: url + "mesh/SpruceSmall2.glb",
			treeType: "conifer",
			trunkColor: "#3A2A16",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		tree6: {
			foliageColor: `hsl(${Math.round(80 * foliageHue)}, 42%, ${Math.round(18 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 0.8,
			heigthScaleFactor: 1,
			largeUrl: url + "mesh/BeechLarge.glb",
			scaleFactor: 0.12 * 2,
			scaleFactorLarge: 0.12,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			simpleUrl: url + "mesh/SimpleTree2.glb",
			smallUrl: url + "mesh/BeechSmall.glb",
			treeType: "leaf",
			trunkColor: "#756F5C",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		tree7: {
			foliageColor: `hsl(${Math.round(80 * foliageHue)}, 42%, ${Math.round(18 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 0.8,
			heigthScaleFactor: 1,
			largeUrl: url + "mesh/AlderLarge.glb",
			scaleFactor: 0.10 * 2,
			scaleFactorLarge: 0.10,
			simpleScaleFactor: 0.13,
			simpleScaleFactorLarge: 0.125,
			simpleUrl: url + "mesh/SimpleTree2.glb",
			smallUrl: url + "mesh/AlderSmall.glb",
			treeType: "leaf",
			trunkColor: "#756F5C",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "tree",
		},
		bush1: {
			foliageColor: `hsl(${Math.round(83 * foliageHue)}, 35%, ${Math.round(27 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			scaleFactor: 0.23,
			scaleFactorLarge: 0.23,
			simpleScaleFactor: 0.23,
			simpleScaleFactorLarge: 0.23,
			simpleUrl: url + "mesh/SimpleBush2.glb",
			treeType: "leaf",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "bush",
			url: url + "mesh/LeafyBush1.glb",
		},
		bush2: {
			foliageColor: `hsl(${Math.round(90 * foliageHue)}, 42%, ${Math.round(25 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			scaleFactor: 0.26,
			scaleFactorLarge: 0.26,
			simpleScaleFactor: 0.23,
			simpleScaleFactorLarge: 0.23,
			simpleUrl: url + "mesh/SimpleBush2.glb",
			treeType: "leaf",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "bush",
			url: url + "mesh/LeafyBush2.glb",
		},
		bush3: {
			foliageColor: `hsl(${Math.round(100 * foliageHue)}, 30%, ${Math.round(20 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			scaleFactor: 0.45,
			scaleFactorLarge: 0.45,
			simpleScaleFactor: 0.23,
			simpleScaleFactorLarge: 0.23,
			simpleUrl: url + "mesh/SimpleBush2.glb",
			treeType: "leaf",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "bush",
			url: url + "mesh/LeafyBush4.glb",
		},
		bush4: {
			foliageColor: `hsl(${Math.round(350 * foliageHue)}, 65%, ${Math.round(24 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			scaleFactor: 0.23,
			scaleFactorLarge: 0.23,
			simpleScaleFactor: 0.23,
			simpleScaleFactorLarge: 0.23,
			simpleUrl: url + "mesh/SimpleBush2.glb",
			treeType: "leaf",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "bush",
			url: url + "mesh/JapaneseMapleBush1.glb",
		},
		bush5: {
			foliageColor: `hsl(${Math.round(100 * foliageHue)}, 30%, ${Math.round(20 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			scaleFactor: 0.24,
			scaleFactorLarge: 0.24,
			simpleScaleFactor: 0.23,
			simpleScaleFactorLarge: 0.23,
			simpleUrl: url + "mesh/SimpleBush2.glb",
			treeType: "conifer",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "bush",
			url: url + "mesh/FirBush1.glb",
		},
		bush6: {
			foliageColor: `hsl(${Math.round(100 * foliageHue)}, 30%, ${Math.round(20 * foliageLightness)}%)`,
			foliageIOR: 1.3,
			foliageRoughness: 8,
			scaleFactor: 0.26,
			scaleFactorLarge: 0.26,
			simpleScaleFactor: 0.23,
			simpleScaleFactorLarge: 0.23,
			simpleUrl: url + "mesh/SimpleBush2.glb",
			treeType: "conifer",
			trunkColor: "hsl(46, 12%, 20%)",
			trunkIOR: 1.3,
			trunkRoughness: 0.8,
			type: "bush",
			url: url + "mesh/FirBush2.glb",
		},
		rocks: {
			type: "structure",
			url: url + "mesh/Rocks.glb",
			ignoreMaterial: true,
		},
		rails: {
			type: "structure",
			url: url + "mesh/Rails.glb",
			ignoreMaterial: true,
		},
		railbeam: {
			type: "structure",
			url: url + "mesh/RailBeam.glb",
			ignoreMaterial: true,
		},
		widePlank: {
			type: "structure",
			url: url + "mesh/WidePlank.glb",
			ignoreMaterial: true,
		},
		thickPlank: {
			type: "structure",
			url: url + "mesh/ThickPlank.glb",
			ignoreMaterial: true,
		},
	}
}
export function getTextures(properties) {
	const {
		grassH,
		grassS,
		grassL,
		greenLightness,
		semiGreenLightness,
		teeLightness,
		fairwayLightness,
		backgroundLightness,
		roughLightness,
		roughHue,
		grassBunkerLightness,
		contrastRoughness,
		grassSizeScale,
		images,
		forestHue,
	} = getProperties(properties)
	return {
		green: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${50 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: `hsl(${grassH} ${Math.round(grassS * 1.3)}% ${greenLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		semigreen: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${70 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: `hsl(${grassH} ${Math.round(grassS)}% ${semiGreenLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		tee: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${70 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: `hsl(${grassH} ${grassS}% ${teeLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		fairway: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${70 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: `hsl(${grassH} ${grassS}% ${fairwayLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}, {
					// 	disabled: false,
					// 	name: 'colorize',
					// 	color: `hsl(${grassH} ${grassS}% ${fairwayLightness}%)`,
					// 	opacity: 0.5,
					// 	gco: 'source-over'
					// }, {
					disabled: false,
					name: 'overlay',
					opacity: 0.05,
					scale: 0.125 / grassSizeScale,
					gco: 'overlay',
					image: url + "materials/fairwayLines.png",
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		rough: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${160 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: `hsl(${roughHue ?? grassH} ${grassS}% ${roughLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		darkGrass: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${160 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: `hsl(${grassH} ${grassS}% ${roughLightness * 0.7}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		background: {
			url: url + "materials/pack002/grass002",
			size: 100 * grassSizeScale,
			images: images,
			compileOptions: {
				diffuse: [{
					disabled: false,
					name: 'filter',
					saturate: "0%",
					contrast: `${90 * contrastRoughness}%`
				}, {
					disabled: false,
					name: 'colorize',
					color: `hsl(${grassH} ${grassS}% ${backgroundLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		grassbunker: {
			url: url + "materials/pack002/grass002",
			size: 160 * grassSizeScale,
			images: images,
			compileOptions: {
				all: [{
					disabled: true,
					name: 'offset',
					top: 10,
					bottom: 10,
					left: 10,
					right: 10,
				}],
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${180 * contrastRoughness}%`
				}, {
					disabled: false,
					name: 'colorize',
					color: `hsl(${grassH} ${grassS}% ${grassBunkerLightness}%)`,
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0.5,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0.5,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0.5,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0.5,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		sand: {
			url: url + "materials/pack002/sand001",
			size: 30,
			images: images,
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%"
				}, {
					name: 'colorize',
					color: '#CBA471',
					opacity: 0.7,
					gco: 'source-over'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		bunker: {
			url: url + "materials/pack002/sand001",
			size: 30,
			images: images,
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%"
				}, {
					name: 'colorize',
					color: '#DDC4A3',
					opacity: 0.7,
					gco: 'source-over'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		forest: {
			url: url + "materials/pack002/forest004",
			size: 20,
			//images: [],
			compileOptions: {
				diffuse: [{
					disabled: false,
					name: 'filter',
					saturate: "20%",
					brightness: "90%",
					contrast: `${70 * contrastRoughness}%`
				}, {
					disabled: false,
					name: 'colorize',
					color: `hsl(${forestHue} ${grassS}% ${roughLightness * 0.9}%)`,
					opacity: 1,
					gco: 'overlay'
				}, {
					disabled: true,
					name: 'colorize',
					color: `hsl(${forestHue} ${grassS}% ${roughLightness * 0.9}%)`,
					opacity: 0.8,
					gco: 'source-over'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		path: {
			url: url + "materials/pack002/gravel001",
			size: 20,
			images: images,
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${60 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: '#8A8369',
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0.01,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0.01,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		railwaygravel: {
			url: url + "materials/pack002/gravel001",
			size: 20,
			images: ["diffuse", "normal", "ao"],
			compileOptions: {
				diffuse: [{
					disabled: true,
					name: 'filter',
					saturate: "0%",
					contrast: `${60 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: '#554037',
					opacity: 0.7,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 1,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0.01,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 1,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0.01,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		road: {
			url: url + "materials/pack002/asphalt001",
			size: 40,
			images: images,
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%"
				}, {
					name: 'colorize',
					color: '#3F3F3E',
					opacity: 0.7,
					gco: 'source-over'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		sheetmetal: {
			url: url + "materials/pack002/sheetmetal001",
			size: 7,
			images: ["diffuse", 'clipping'],
			compileOptions: {
				diffuse: [{
					disabled: true,
					name: 'filter',
					contrast: `50%`
				}, {
					name: 'overlay',
					opacity: 0.02,
					scale: 1,
					gco: 'overlay',
					image: url + "materials/noise.png"
				}],
			}
		},
		tarpaper: {
			url: url + "materials/pack002/asphalt001",
			size: 30,
			images: ["diffuse", "normal", "displacement", "ao", "roughness"],
			compileOptions: {
				diffuse: [{
					disabled: false,
					name: 'filter',
					contrast: `50%`
				}],
			}
		},
		mountain: {
			url: url + "materials/pack002/rock002",
			size: 30,
			images: ["diffuse"],
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: `${50 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: '#7D7B7B',
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0.2,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0.2,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0.2,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		rock: {
			url: url + "materials/pack002/rock003",
			size: 12,
			images: ["diffuse", "normal", "displacement", "ao", "roughness"],
			compileOptions: {
				diffuse: [{
					disabled: false,
					name: 'colorize',
					color: '#7D7B7B',
					opacity: 0.5,
					gco: 'source-over'
				}, {
					disabled: true,
					name: 'overlay',
					opacity: 0.5,
					scale: 1,
					gco: 'overlay',
					image: url + "materials/noise.png"
				}
				],
				// normal: [{
				// 	name: 'alpha',
				// 	opacity: 0.7,
				// 	background: 'rgba(128,128,255,1)',
				// 	gco: 'source-over'
				// }],
				// displacement: [{
				// 	name: 'alpha',
				// 	opacity: 0.05,
				// 	background: 'rgba(128,128,128,1)',
				// 	gco: 'source-over'
				// }],
				// ao: [{
				// 	name: 'alpha',
				// 	opacity: 1,
				// 	background: 'rgba(255,255,255,1)',
				// 	gco: 'source-over'
				// }],
				// roughness: [{
				// 	name: 'alpha',
				// 	opacity: 0.3,
				// 	background: 'rgba(255,255,255,1)',
				// 	gco: 'source-over'
				// }],
			}
		},
		wastearea: {
			url: url + "materials/pack002/sand001",
			size: 40,
			images: images,
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "50%",
					contrast: `${120 * contrastRoughness}%`
				}, {
					name: 'colorize',
					color: 'hsl(52,25%,35%)',
					opacity: 0.7,
					gco: 'overlay'
				}, {
					default: true,
					name: 'colorize',
					color: 'hsl(52,25%,35%)',
					opacity: 0.7,
					gco: 'source-over'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0.3,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		waterSurface: {
			url: url + "materials/pack002/water002",
			size: 20,
			images: ["diffuse", "normal", "displacement", "ao", "roughness"],
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: "50%"
				}, {
					name: 'colorize',
					color: 'hsl(158, 40%, 18%)',
					opacity: 1,
					gco: 'overlay'
				}, {
					disabled: false,
					name: 'colorize',
					color: 'hsl(158, 40%, 18%)',
					opacity: 0.3,
					gco: 'source-over'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		waterBottom: {
			url: url + "materials/pack002/sand002",
			size: 50,
			images: ["diffuse"],
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: "60%"
				}, {
					name: 'colorize',
					color: 'hsl(162, 40%, 25%)',
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		},
		streamBottom: {
			url: url + "materials/pack002/sand002",
			size: 50,
			images: ["diffuse"],
			compileOptions: {
				diffuse: [{
					name: 'filter',
					saturate: "0%",
					contrast: "60%"
				}, {
					name: 'colorize',
					color: 'hsl(162, 40%, 25%)',
					opacity: 1,
					gco: 'overlay'
				}],
				normal: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,255,1)',
					gco: 'source-over'
				}],
				displacement: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(128,128,128,1)',
					gco: 'source-over'
				}],
				ao: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
				roughness: [{
					name: 'alpha',
					opacity: 0,
					background: 'rgba(255,255,255,1)',
					gco: 'source-over'
				}],
			}
		}
	}
}